module.exports = __webpack_public_path__ + "img/caritas.42d4850.png";